export interface ChecklistMediaTerminalEvent {
  companyId: string;
  checklistId: string;
  fieldId: string;
  expectedValue: string;
  localUri: string;
  uri: string;
  expectedObservation: string | null;
  observation: string | null;
}

const listeners = new Set<(event: ChecklistMediaTerminalEvent) => void>();
export const subscribeChecklistMediaTerminal = (listener: (event: ChecklistMediaTerminalEvent) => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

/** Publicado somente depois do commit local que confirma a tentativa exata. */
export const publishChecklistMediaTerminal = (event: ChecklistMediaTerminalEvent): void => {
  for (const listener of listeners) {
    try { listener(event); } catch (error) { console.warn('Falha ao atualizar prévia da mídia confirmada.', error); }
  }
};
